import { normalizeCountry } from '../utils/countries';
import { PALETTE } from '../utils/palette';
import { drawDonut } from '../utils/canvas';

export const CHART_KEY = [
    'Riders in the ranking grouped by nationality',
    'Donut shows share · list shows count',
    'Tap a slice for detail',
];

/**
 * Shared primitive — renders donut + returns legend array.
 * @param {HTMLCanvasElement} canvas
 * @param {HTMLElement} tooltip
 * @param {string[]} labels
 * @param {number[]} data
 * @returns {{ label: string, count: number, color: string }[]}
 */
export function renderCountryDonut(canvas, tooltip, labels, data) {
    if (!canvas || !labels.length) return [];
    drawDonut(canvas, tooltip, labels, data, PALETTE);
    return labels.slice(0, 12).map((label, i) => ({ label, count: data[i], color: PALETTE[i % PALETTE.length] }));
}

/**
 * Ranking variant — builds country counts from raw riders array.
 * @param {HTMLCanvasElement} canvas
 * @param {HTMLElement} tooltip
 * @param {Array} riders
 * @returns {{ label: string, count: number, color: string }[]}
 */
export function renderCountryBar(canvas, tooltip, riders) {
    if (!canvas || !riders.length) return [];
    const countMap = {};
    riders.forEach(r => {
        const c = normalizeCountry(r.data?.country);
        countMap[c] = (countMap[c] || 0) + 1;
    });
    const sorted = Object.entries(countMap).sort((a, b) => b[1] - a[1]);
    return renderCountryDonut(canvas, tooltip, sorted.map(([c]) => c), sorted.map(([, n]) => n));
}
